export function toggleAccordion(selector) {
    if (selector) {
        var questions = document.querySelectorAll(".accordion_question");
        for (var j = 0; j < questions.length; j++) {
            var text = questions[j].querySelector('.accordion_text'), height = text.scrollHeight;
            questions[j].setAttribute('style', "--element-height:".concat(height, "px;"));
            questions[j].onclick = function () {
                var currentQuestion = this;
                if (!currentQuestion.classList.contains("open")) {
                    for (var z = 0; z < questions.length; z++) {
                        questions[z].classList.remove("open");
                    }
                    currentQuestion.classList.add("open");
                }
                else {
                    currentQuestion.classList.remove("open");
                }
            };
        }
    }
}
